"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_FAILED = exports.STATUS_TESTED = exports.STATUS_TESTING = exports.STATUS_QUEUED = exports.STATUS_SLEEP = void 0;
exports.STATUS_SLEEP = "sleep";
exports.STATUS_QUEUED = "queued";
exports.STATUS_TESTING = "testing";
exports.STATUS_TESTED = "tested";
exports.STATUS_FAILED = "failed";
